export type ExpandArrowPlacement =
  | "bottom"
  | "top"
  | "bottomLeft"
  | "bottomRight"
  | "topLeft"
  | "topRight";

/** 按弹出层展开方向切换箭头：向下展开收起为 down、展开为 up；向上展开则相反 */
export function resolveExpandArrowIcon(
  open: boolean,
  placement: ExpandArrowPlacement = "bottom"
): "up" | "down" {
  const opensUpward = placement.startsWith("top");
  if (opensUpward) {
    return open ? "down" : "up";
  }
  return open ? "up" : "down";
}
